import { Menu } from '../primitives';
import type { MenuItem } from '../primitives/Menu';

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export interface SectionNewMenuProps {
  /** Trigger label, e.g. "New epic" / "New item" / "New doc". */
  label: string;
  /** Menu rows — typically "Create …" entries plus "Attach existing…". */
  items: MenuItem[];
  /** Accessible label for the popover menu. */
  menuLabel: string;
  triggerTestId: string;
}

/**
 * The "New ▾" section header control on the Project page: a `pn-newbtn`-styled
 * trigger opening a `Menu` that offers creating a new object (in a full-screen
 * cover) or attaching an existing one.
 */
export function SectionNewMenu({
  label,
  items,
  menuLabel,
  triggerTestId
}: SectionNewMenuProps) {
  return (
    <Menu
      label={menuLabel}
      align="end"
      items={items}
      trigger={(api) => (
        <button
          type="button"
          className="pn-newbtn"
          data-testid={triggerTestId}
          {...api}
        >
          <PlusIcon />
          {label}
          <span aria-hidden="true">▾</span>
        </button>
      )}
    />
  );
}
